import React from 'react';
import Icon from '../../../components/AppIcon';

const WelcomeMessage = ({ onQuickStart }) => {
  const quickStartOptions = [
    {
      id: 1,
      title: 'سوال سریع',
      description: 'پرسش فوری از ایران‌داد ',
      icon: 'MessageSquare',
      action: () => onQuickStart('سوال سریع'),
    },
    {
      id: 2,
      title: 'مشاوره تخصصی',
      description: 'ارتباط با وکیل متخصص',
      icon: 'User',
      action: () => onQuickStart('مشاوره تخصصی'),
    },
    {
      id: 3,
      title: 'بررسی قرارداد',
      description: 'تحلیل و بررسی اسناد حقوقی',
      icon: 'FileText',
      action: () => onQuickStart('بررسی قرارداد'),
    },
  ];

  return (
    <div className="flex-1 flex items-center justify-center p-6">
      <div className="max-w-md w-full text-center">
        {/* Welcome Icon */}
        <div className="w-20 h-20 bg-primary rounded-full flex items-center justify-center mx-auto mb-6 shadow-moderate">
          <Icon name="Scale" size={40} color="white" />
        </div>

        {/* Welcome Text */}
        <h2 className="text-2xl font-bold text-foreground mb-3">
          به ایران داد خوش آمدید
        </h2>
        <p className="text-muted-foreground mb-8 leading-relaxed">
          سوالات حقوقی خود را بپرسید و پاسخ‌های دقیق و فوری دریافت کنید. ما
          اینجا هستیم تا به شما کمک کنیم.
        </p>

        {/* Quick Start Options */}
        <div className="space-y-3 mb-8">
          {/* <h3 className="text-sm font-medium text-foreground mb-4">
            شروع سریع
          </h3> */}
          {/* {quickStartOptions?.map((option) => (
            <button
              key={option?.id}
              onClick={option?.action}
              className="w-full flex items-center p-4 text-right bg-card hover:bg-muted border border-border rounded-lg transition-smooth focus-ring group">
              <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center ml-4 group-hover:bg-primary/20 transition-smooth">
                <Icon name={option?.icon} size={20} className="text-primary" />
              </div>
              <div className="flex-1">
                <h4 className="text-sm font-medium text-card-foreground mb-1">
                  {option?.title}
                </h4>
                <p className="text-xs text-muted-foreground">
                  {option?.description}
                </p>
              </div>
              <Icon
                name="ChevronLeft"
                size={16}
                className="text-muted-foreground group-hover:text-foreground transition-smooth"
              />
            </button>
          ))} */}
        </div>

        {/* Help Text */}
        <div className="p-4 bg-muted rounded-lg">
          <div className="flex items-center justify-center mb-2">
            <Icon
              name="Info"
              size={16}
              className="text-muted-foreground ml-2"
            />
            <span className="text-sm font-medium text-muted-foreground">
              نکته مهم
            </span>
          </div>
          <p className="text-xs text-muted-foreground leading-relaxed">
            پاسخ‌های ارائه شده توسط ربات جنبه مشاورهای دارد و جایگزین مشاوره
            حقوقی تخصصی نیست.
          </p>
        </div>
      </div>
    </div>
  );
};

export default WelcomeMessage;
